export default __webpack_public_path__ + "static/media/crossIcon.0842d242.svg";